import React from 'react';
import './articles.scss';

import {handleAuthError, useCheckUserAuthentication,fetchLookup} from '../../globals';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  //Pager,
  //Paging,
  //FilterRow,
  Export,
  HeaderFilter,
  Lookup,
  Editing,
  Popup,
  Form,
  Selection,
  Format,
  Summary,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useState, useEffect } from "react";
import { Item} from 'devextreme-react/form';

//npm install exceljs
import { Workbook } from 'exceljs';
//npm install file-saver --save
import { saveAs } from 'file-saver';
import { exportDataGrid } from 'devextreme/excel_exporter';

//import { formatNumber } from 'devextreme/localization';


export default function Articles() {

  const [fornitori, setFornitori] = useState({});
  const [tipi, setTipi] = useState({});
  const [imposte, setImposte] = useState({});
  const [valute, setValute] = useState({});
  const [categorie, setCategorie] = useState({});
  const [UMs, setUMs] = useState({});

  const [tensioni, setTensioni] = useState({});
  const [sezioni, setSezioni] = useState({});
  const [conduttori, setConduttori] = useState({});
  //const [schermi, setSchermi] = useState({});
  
  const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Articolo'

  const user = useCheckUserAuthentication();

  const remoteDataSource = createStore({
    key: 'id',
    loadUrl: serviceUrl + '/GetAction',
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction',
    
    // onBeforeSend: (method, ajaxOptions) => {
    //   ajaxOptions.headers = {
    //     ...(ajaxOptions.headers || {}),
    //     Authorization: `Bearer ${user.token}`
    //   };
    // },

    errorHandler: (error) => {
      handleAuthError(error);
    }
    
  });

  useEffect(() => {

    const newServiceUrl1 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
    var newUrl1 =  newServiceUrl1 + "/GetFornitoriAlias";

    const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
    var newUrl2 =  newServiceUrl2 + "/GetAction";

    const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
    var newUrl3 =  newServiceUrl3 + "/GetAction";

    const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
    var newUrl4 =  newServiceUrl4 + "/GetAction";

    const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ArticoloCategoria';
    var newUrl5 =  newServiceUrl5 + "/GetAction";

    const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
    var newUrl6 =  newServiceUrl6 + "/GetAction";

    const newServiceUrl11 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CavoTensione';
    var newUrl11 =  newServiceUrl11 + "/GetAction";

    const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CavoSezione';
    var newUrl12 =  newServiceUrl12 + "/GetAction";

    const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CavoConduttore';
    var newUrl13 =  newServiceUrl13 + "/GetAction";

    // const newServiceUrl14 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CavoSchermo';
    // var newUrl14 =  newServiceUrl14 + "/GetAction";

     

    const fetchData = async () => {
        
      if (!user?.token) {
        return;
      }

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const json1 = await fetchLookup(newUrl1,requestOptions);
        if (json1) {
          setFornitori(json1);
        }

        const response2 = await fetch(newUrl2);
        const json2 = await response2.json();
        //console.log(json2);
        setTipi(json2);

        const response3 = await fetch(newUrl3);
        const json3 = await response3.json();
        //console.log(json3);
        setImposte(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        //console.log(json4);
        setValute(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        //console.log(json5);
        setCategorie(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        //console.log(json6);
        setUMs(json6);

        const response11 = await fetch(newUrl11);
        const json11 = await response11.json();
        //console.log(json11);
        setTensioni(json11);

        const response12 = await fetch(newUrl12);
        const json12 = await response12.json();
        //console.log(json12);
        setSezioni(json12);

        const response13 = await fetch(newUrl13);
        const json13 = await response13.json();
        //console.log(json13);
        setConduttori(json13);

        // const response14 = await fetch(newUrl14);
        // const json14 = await response14.json();
        // console.log(json14);
        // setSchermi(json14);

  
      } catch (error) {
        console.log("error", error);
      }
    };
      fetchData();
    }, [user?.token]); // Aggiorna se il token cambia

    function onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Main sheet');
  
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Articoli.xlsx');
        });
      });
      e.cancel = true;
    }

    function formFieldDataChanged3(newData, value, currentRowData) {

      newData.prezzoAcquisto = value;
      newData.prezzoIndicativo = 0;
      newData.percRicarico = 0;
    }

    function formFieldDataChanged1(newData, value, currentRowData) {

      //200 : 100 = D : x
      newData.prezzoIndicativo = value;
      if(currentRowData.prezzoAcquisto !== null && currentRowData.prezzoAcquisto !== 0)
      {
        var perc = 100 * (value - currentRowData.prezzoAcquisto)/currentRowData.prezzoAcquisto;
        perc = perc.toFixed(4);
        newData.percRicarico = perc;
        //newData.percRicarico = 100 * (value - currentRowData.prezzoAcquisto)/currentRowData.prezzoAcquisto;
      }
  
    }

    function formFieldDataChanged2(newData, value, currentRowData) {

      //200 : 100 = D : 20
      newData.percRicarico = value;
      if(currentRowData.prezzoAcquisto !== null && currentRowData.prezzoAcquisto !== 0)
      {
        var prezzo = currentRowData.prezzoAcquisto + ((currentRowData.prezzoAcquisto * newData.percRicarico)/100);
        prezzo = prezzo.toFixed(4);
        newData.prezzoIndicativo = prezzo;
        //newData.prezzoIndicativo = currentRowData.prezzoAcquisto + ((currentRowData.prezzoAcquisto * newData.percRicarico)/100);
      }
      //var discount = (price / listprice).toFixed(2);
    }

    function onInitNewRow(e) {
      e.data.listinoFornitore = 0;
      e.data.prezzoAcquisto = 0;
      e.data.prezzoIndicativo = 0;
      e.data.percRicarico = 0;
      e.data.valutaId = 1;
  }

//   function isCategoriaCavo(id){

//     const cat = categorie.find(c=>c.id===id);

//     return cat?.isCavo;
//   }

//   function customizeItem(item) {

//     if (item.name === "grpCavo") {

//         const formData = item.component.option("formData");

//         item.visible = isCategoriaCavo(formData.categoriaId);
//     }
//   }

// function onEditorPreparing(e) {

//     if (e.parentType !== "dataRow")
//         return;

//     if (e.dataField === "categoriaId") {

//       const original = e.editorOptions.onValueChanged;

//       e.editorOptions.onValueChanged = function(args) {

//         if (original) {
//             original(args);
//         }

//         // forza l'aggiornamento del form
//         e.component.repaint();
//       };
//     }
// }

  return(
  <React.Fragment>
    <h2 className={'content-block'}>Articoli</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>

      <DataGrid
        dataSource={remoteDataSource}
        onExporting={onExporting}
        onInitNewRow={onInitNewRow}
        //onEditorPreparing={onEditorPreparing}
        focusedRowEnabled={true}
        >
        <HeaderFilter visible={true} />
        <Summary>
          <TotalItem
              column="descrizione"
              summaryType="count"
          />
        </Summary>
         <SearchPanel visible={true} width={240} placeholder="Cerca..." />
        <Selection mode="single" />
        <Editing
          mode="popup"
          useIcons={true}
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}     
        >
           <Popup   title= "Articolo " showTitle={true} width={800} height={625} />
          <Form >
            <Item itemType="group" caption="Dati Generali" colCount={2} colSpan={2}>
         
              <Item dataField="codice" disabled={true}/>
              <Item dataField="tipoArticoloId" isRequired= "true"/>
              <Item dataField="descrizione" colSpan={2} editorType="dxTextArea" /> 
              <Item dataField="fornitoreId" isRequired= "true"/> 
              <Item dataField="codiceFornitore" isRequired= "true"/> 
              <Item dataField="categoriaId" isRequired= "true"/>
              <Item dataField="impostaId" isRequired= "true"/>
              <Item dataField="umid" isRequired= "true"/>
              <Item dataField="valutaId" isRequired= "true"/>
              <Item dataField="listinoFornitore" />
              <Item dataField="prezzoAcquisto" />
              <Item dataField="prezzoIndicativo" />
              <Item dataField="percRicarico" />
              
            </Item>  
            <Item itemType="group" caption="Dati Cavo" name="grpCavo" colCount={2} colSpan={2}>

              <Item dataField="articoloCavo.tensioneId" editorOptions={{showClearButton: true}}/>  
              <Item dataField="articoloCavo.sezioneId" editorOptions={{showClearButton: true}}/>  
              <Item dataField="articoloCavo.conduttoreId" editorOptions={{showClearButton: true}}/>  
              
            </Item> 

          </Form> 
        </Editing>   
        <Column dataField="id" visible={false}/>
        <Column dataField="tipoArticoloId" caption="Tipo" width={120}>
          <Lookup dataSource={tipi} displayExpr="nome" valueExpr="id" />
        </Column>
        <Column dataField="codice" width={80} />
        <Column dataField="descrizione" width={500}/>
   
        <Column dataField="fornitoreId" caption="Fornitore" width={120} >
          <Lookup dataSource={fornitori} displayExpr="alias" valueExpr="id" />
        </Column>

        <Column dataField="codiceFornitore" caption="Cod. Art. Fornitore" />
        <Column dataField="categoriaId" caption="Categoria" width={200}  >
          <Lookup dataSource={categorie} displayExpr="nome" valueExpr="id" />
        </Column>
        <Column dataField="valutaId" caption="Valuta" width={80} >
          <Lookup dataSource={valute} displayExpr="codice" valueExpr="id" />
        </Column>
        <Column dataField="impostaId" caption="Imposta" visible={false} >
          <Lookup dataSource={imposte} displayExpr="codice" valueExpr="id" />
        </Column>
        <Column dataField="umid" caption="UM" visible={false} >
          <Lookup dataSource={UMs} displayExpr="codice" valueExpr="id" />
        </Column>
        <Column dataField="prezzoAcquisto" caption="Prezzo Acquisto" setCellValue={formFieldDataChanged3}>
          <Format type="fixedPoint" precision={4} />
        </Column>
        <Column dataField="prezzoIndicativo" caption="PV Indicativo" setCellValue={formFieldDataChanged1}>
          <Format type="fixedPoint" precision={4} />
        </Column>
   
        <Column dataField="listinoFornitore"visible={false} >
          <Format type="fixedPoint" precision={4} />
        </Column>
        <Column dataField="percRicarico"visible={false} setCellValue={formFieldDataChanged2}>
          <Format type="fixedPoint" precision={4} />
        </Column>

        <Column dataField="articoloCavo.tensioneId" caption="Tensione" visible={false} >
          <Lookup dataSource={tensioni} displayExpr="codice" valueExpr="id" />
        </Column>

        <Column dataField="articoloCavo.sezioneId" caption="Sezione" visible={false} >
          <Lookup dataSource={sezioni} displayExpr="codice" valueExpr="id" />
        </Column>

        <Column dataField="articoloCavo.conduttoreId" caption="Conduttore" visible={false} >
          <Lookup dataSource={conduttori} displayExpr="codice" valueExpr="id" />
        </Column>

       

        <Export enabled={true} allowExportSelectedData={false} />

      </DataGrid>  
      </div>
    </div>
  </React.Fragment>
)
};
